// 设置 模式切换

function setViewMode (mode, CB, self) {
  self = self || this
  const viewer = self.viewer
  switch (mode) {
    case '3D': {
      // 三维
      viewer.scene.morphTo3D(1.0)
      return true
    }
    case '2D': {
      // 二维
      viewer.scene.morphTo2D(1.0)
      // viewer.scene.camera.zoomOut(20e6)
      return true
    }
    case '2.5D': {
      // 哥伦布视图 2.5D
      viewer.scene.morphToColumbusView(1.0)
      return true
    }
    default: {
      break
    }
  }

  return false
}

export { setViewMode }
